export const crmProspectList = 'crm-prospect-list';
export const crmProspectDetails = 'crm-prospect-details';
export const crmUnreadSMS = 'crm-unread-sms';
